module.exports = "//static.hsappstatic.net/LoginUI/static-1.16083/img/donut_desktop.svg"